import { Add as AddIcon, Remove as RemoveIcon } from "@mui/icons-material";
import { FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput } from "@mui/material";
import { Field } from "react-final-form";

import { type CapacityCounterProps } from "../../organisms/AddEventTimesModal/AddEventTimesModal.types";
import { formatCapacityText } from "../../organisms/AddEventTimesModal/AddEventTimesModal.utils";

const toCapacityNumber = (value: unknown): number => {
  const numericValue = Number(value ?? 0);
  return Number.isFinite(numericValue) ? numericValue : 0;
};

export const CapacityCounter = ({ name, label, required }: CapacityCounterProps) => {
  return (
    <Field name={name} initialValue={0}>
      {({ input }) => {
        const currentValue = toCapacityNumber(input.value);

        const increment = () => {
          input.onChange(currentValue + 1);
        };

        const decrement = () => {
          input.onChange(Math.max(0, currentValue - 1));
        };

        const displayValue = formatCapacityText(currentValue);
        const inputId = `capacity-input-${name}`;

        return (
          <FormControl fullWidth required={required} variant="outlined">
            <InputLabel htmlFor={inputId} shrink>
              {label}
            </InputLabel>
            <OutlinedInput
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="Increase capacity"
                    edge="end"
                    onClick={increment}
                    onMouseDown={(event) => event.preventDefault()}
                    size="small"
                  >
                    <AddIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              }
              id={inputId}
              inputProps={{ "aria-label": label, readOnly: true }}
              label={label}
              notched
              readOnly
              startAdornment={
                <InputAdornment position="start">
                  <IconButton
                    aria-label="Decrease capacity"
                    disabled={currentValue === 0}
                    edge="start"
                    onClick={decrement}
                    onMouseDown={(event) => event.preventDefault()}
                    size="small"
                  >
                    <RemoveIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              }
              sx={{
                "& input": {
                  cursor: "default",
                  fontWeight: currentValue === 0 ? 400 : 700,
                  textAlign: "center",
                },
              }}
              value={displayValue}
            />
          </FormControl>
        );
      }}
    </Field>
  );
};
